<template>
  <div class="bs-docs-section text-center pt-1 mx-3" id="testimonials">
    <div class="jumbotron">
      <div class="row">
        <div class="col-lg-12">
          <div class="page-header text-center">
            <h4 id="containers">Testimonials</h4>
            <hr class="w-80" />
          </div>
        </div>
      </div>
      <div class="row row-cols-1 justify-content-md-center">
        <div class="col col-md-offset-2 col-sm-offset-2 col-md-8 col-sm-8">
          <div v-if="Finult_Testimonials.length > 1">
            <carousel :autoplay="true" :items="1" :nav="false">
              <div
                class="testimonial"
                v-for="(testimonial, index) in Finult_Testimonials"
                :key="index"
              >
                <div class="testimonial-content">
                  <p class="description">{{ testimonial.testimonial_desc }}</p>
                </div>
                <div class="testimonial-profile">
                  <div class="pic">
                    <!--img class="img-fluid" :src="testimonial.photo" alt="card image" :key="index">-->
                  </div>
                  <h3 class="title">
                    {{ testimonial.client_name }}
                    <span class="post" v-html="testimonial.client_title"></span>
                  </h3>
                </div>
              </div>
            </carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import jsonData from "@/components/json/Finult_Testimonials.json";
export default {
  components: { carousel },
  name: "Testimonials",
  data() {
    return {
      Finult_Testimonials: []
    };
  },
  created() {
    console.log(this.$useFirestore);
    if (this.$useFirestore) {
      this.Finult_Testimonials = this.$options.filters.getFireStoreRecords(
        "Finult_Testimonials"
      );
    } else {
      this.Finult_Testimonials = jsonData.Finult_Testimonials;
    }
  }
};
</script>
